import { ConfirmationOptions, ConfirmationState, DialogProvider, useDialog } from "./DialogContext";

export type { ConfirmationOptions, ConfirmationState };

export const ConfirmationProvider = DialogProvider;

export function useConfirmation() {
    const { confirm, pending, handleConfirm, handleCancel } = useDialog();

    return {
        confirm,
        pending: pending?.variant === "confirmation" ? pending as ConfirmationState : null,
        handleConfirm,
        handleCancel,
    };
}
